import React, { useState } from "react";
import _ from "lodash";
import Swal from "sweetalert2";
import { BsPlusLg } from "react-icons/bs";
import { delete_customer_object } from "../../../functions/api";
import { makeNewObject, isTempObject, getNextObjectNumber } from "./objectModel";
import ObjectCard from "./ObjectCard";
import ObjectDrawer from "./ObjectDrawer";

const ObjectenSection = ({ objecten, customerDefaults, onChange }) => {
  const [drawer, setDrawer] = useState({
    open: false,
    mode: "create",
    editingIndex: -1,
    initialValue: null,
  });

  const closeDrawer = () => setDrawer((d) => ({ ...d, open: false }));

  const handleAdd = () =>
    setDrawer({
      open: true,
      mode: "create",
      editingIndex: -1,
      initialValue: makeNewObject({
        ...customerDefaults,
        nummer: getNextObjectNumber(objecten),
      }),
    });

  const handleCardClick = (i) =>
    setDrawer({
      open: true,
      mode: "edit",
      editingIndex: i,
      initialValue: _.cloneDeep(objecten[i]),
    });

  const handleSave = (draft) => {
    if (drawer.mode === "create") {
      onChange([...objecten, draft]);
    } else {
      onChange(objecten.map((o, i) => (i === drawer.editingIndex ? draft : o)));
    }
    closeDrawer();
  };

  const handleDelete = (object, index) => {
    Swal.fire({
      title: "Weet je het zeker?",
      text: "Wil je dit object verwijderen?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ja, verwijder het!",
      cancelButtonText: "Annuleren",
    }).then(async ({ isConfirmed }) => {
      if (!isConfirmed) return;
      try {
        if (!isTempObject(object)) {
          const r = await delete_customer_object(object.objectid);
          if (!r?.ok) throw new Error("delete failed");
        }
        onChange(objecten.filter((_, i) => i !== index));
        Swal.fire("Verwijderd!", "Het object is succesvol verwijderd.", "success");
      } catch (e) {
        console.error("removeObject", e);
        Swal.fire(
          "Fout!",
          "Er is een fout opgetreden tijdens het verwijderen.",
          "error"
        );
      }
    });
  };

  return (
    <section className="flex flex-col space-y-4 mt-6">
      <div className="flex items-center justify-between border-b pb-2">
        <h2 className="text-xl font-semibold">Objecten</h2>
        <button
          type="button"
          onClick={handleAdd}
          className="px-4 py-1 bg-green-500 text-white text-sm font-semibold rounded-md shadow-sm hover:bg-green-600 flex items-center gap-2"
        >
          <BsPlusLg /> Object toevoegen
        </button>
      </div>

      {objecten.length === 0 ? (
        <p className="text-gray-500 text-center py-4">
          Nog geen objecten. Klik op '+ Object toevoegen' om er een toe te voegen.
        </p>
      ) : (
        <div className="flex flex-col space-y-2">
          {objecten.map((obj, i) => (
            <ObjectCard
              key={obj.objectid || `idx-${i}`}
              object={obj}
              onClick={() => handleCardClick(i)}
              onDelete={() => handleDelete(obj, i)}
            />
          ))}
        </div>
      )}

      <ObjectDrawer
        show={drawer.open}
        mode={drawer.mode}
        initialValue={drawer.initialValue}
        onSave={handleSave}
        onCancel={closeDrawer}
      />
    </section>
  );
};

export default ObjectenSection;
